<template>
  <li class="border-gray-400 flex flex-col">
    <div class="transition duration-500 bg-white dark:bg-gray-800 rounded-md flex flex-1 items-center p-4">
      <div :title="status" class="item-icon">
        <svg style="width:24px;height:24px" class="fill-current" :class="iconClass" viewBox="0 0 24 24">
          <path v-if="status == 'ok'" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
          <path v-if="status == 'cancelada'" d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" />
          <path v-if="status == 'vencida'" d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
        </svg>
      </div>
      <div class="flex-1 pl-1 md:mr-16">
        <div class="font-medium dark:text-white">
          {{ licenca.codModulo }}
        </div>
        <div class="dark:text-gray-200 text-sm">
          {{ licenca.modulo.descricao }}
        </div>
      </div>
      <div class=" md:mr-16">
        <div class="font-medium dark:text-white">
          Validade
        </div>
        <div class="text-gray-600 dark:text-gray-200 text-sm" :class="textValidadeClass">
          {{ validade }}
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { DateTime } from 'luxon'
export default {
  name: 'ItemLicence',
  props: {
    licenca:  Object,
  },
  computed: {
    validade(){
      const dtInicio = DateTime.fromISO(this.licenca.dtInicio)
      return dtInicio.plus({months: this.licenca.validade}).toFormat('dd/MM/yyyy')
    },
    status() {
      const validade = DateTime.fromISO(this.licenca.dtInicio).plus({months: this.licenca.validade})
      if(this.licenca.dtCancelamento != null){
        return 'cancelada'
      }
      if(validade <= DateTime.now()){
        return 'vencida'
      }
      return 'ok'
    },
    textValidadeClass(){
      return {}
    },
    iconClass(){
      return {
        'text-green-600' : this.status == 'ok',
        'text-red-600' : this.status == 'cancelada',
        'text-orange-600' : this.status == 'vencida',
      }
    },
  },
  created(){
    console.log(this.licenca)
  },
}
</script>

<style>
 .item-icon{
     padding-right: 10px;
 }
</style>
